<form
  [formGroup]="workScheduleForm"
  (ngSubmit)="onSubmit()"
  [hasUnsavedData]="workScheduleForm"
>
  <button type="submit" hidden="hidden"></button>

  <div class="row mb-2">
    <div class="col-12 col-md-6 mr-auto">
      <div class="form-group">
        <label class="form-title-label" for="name" translate>WORK_SCHEDULE_LBL_NAME</label>
        <input
          id="name"
          class="form-control form-title"
          type="text"
          formControlName="name"
          checkFormFieldValidity
          [maxLength]="100"
        />
      </div>
    </div>
  </div>

  @if (isEditMode) {
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" for="active" translate>WORK_SCHEDULE_LBL_ACTIVE</label>
          <div class="col">
            <input
              id="active"
              class="form-control-sm"
              type="checkbox"
              formControlName="active"
              checkFormFieldValidity
            />
          </div>
        </div>
      </div>
    </div>
  }

  <div class="row mt-3">
    <div class="col-12 col-md-6 mr-auto">
      <div class="days-block">
        <label class="col-form-label-sm mb-1" translate>WORK_SCHEDULE_LBL_DAYS</label>

        <div class="table-responsive">
          <table class="table table-sm align-middle mb-1" formArrayName="days">
            <thead>
              <tr>
                <th translate>WORK_SCHEDULE_LBL_DAY_OF_WEEK</th>
                <th class="text-center" translate>WORK_SCHEDULE_LBL_WORKED</th>
                <th translate>WORK_SCHEDULE_LBL_START_TIME</th>
                <th translate>WORK_SCHEDULE_LBL_END_TIME</th>
                <th class="text-end" translate>WORK_SCHEDULE_LBL_AMPLITUDE</th>
              </tr>
            </thead>
            <tbody>
              @for (row of days.controls; track $index; let i = $index) {
                @let endTime = row.get('endTime');
                <tr [formGroupName]="i">
                  <td>{{ dayLabelKeys[i] | translate }}</td>
                  <td class="text-center">
                    <input
                      class="form-control-sm"
                      type="checkbox"
                      formControlName="worked"
                      checkFormFieldValidity
                    />
                  </td>
                  <td>
                    <input
                      class="form-control form-control-sm"
                      type="time"
                      formControlName="startTime"
                      checkFormFieldValidity
                    />
                  </td>
                  <td>
                    <input
                      class="form-control form-control-sm"
                      type="time"
                      formControlName="endTime"
                      checkFormFieldValidity
                    />
                    @if (endTime?.hasError('endBeforeStart') && (endTime?.touched || endTime?.dirty)) {
                      <div class="invalid-feedback d-block" translate>WORK_SCHEDULE_MSG_END_BEFORE_START</div>
                    }
                  </td>
                  <td class="text-end text-nowrap">{{ rowAmplitudeLabels[i] }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (days.hasError('noWorkedDay') && (days.touched || days.dirty)) {
          <div class="invalid-feedback d-block" translate>WORK_SCHEDULE_MSG_NO_WORKED_DAY</div>
        }
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <label class="col-form-label-sm mt-3" translate>WORK_SCHEDULE_LBL_PREVIEW</label>
      <app-work-schedule-week [days]="previewDays" />
    </div>
  </div>
</form>
